import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import { BaivietAction } from 'src/actions/baiviet.action';

import numeral from 'numeral';

import iconMobifone from "../../assets/images/icon_mobifone.png";
import iconVinaphone from "../../assets/images/icon_vinaphone.png";
import iconViettel from "../../assets/images/icon_viettel.png";
import logoNhaMang from "../../assets/images/logo_mang.svg";

const TheHomepageBaivietOne = ({ product }) => {
    const dispatch = useDispatch()
    const { itemId } = useParams();
    const { homepageBaivietSelected } = useSelector(state => state.baiviet)
    const [title, setTitle] = useState("");
    const [titleFont, setTitleFont] = useState("");
    const [titleFontSize, setTitleFontSize] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [shortDescriptionFont, setShortDescriptionFont] = useState("");
    const [shortDescriptionFontSize, setShortDescriptionFontSize] = useState("");
    const [image, setImage] = useState("");
    const [content, setContent] = useState("");
    const { isLoading } = useSelector(state => state.app);
    
    useEffect(() => {
        console.log(itemId);
        dispatch(BaivietAction.homepageFindOne(itemId));
    }, [itemId])

    useEffect(() => {
        console.log(homepageBaivietSelected);

        setTitle('');
        setTitleFont('');
        setTitleFontSize('');
        setShortDescription('');
        setShortDescriptionFont('');
        setShortDescriptionFontSize('');
        setImage('');
        setContent('');

        if (homepageBaivietSelected) {
            setTitle(homepageBaivietSelected.title ? homepageBaivietSelected.title : '');
            setTitleFont(homepageBaivietSelected.title_font ? homepageBaivietSelected.title_font : '');
            setTitleFontSize(homepageBaivietSelected.title_font_size ? homepageBaivietSelected.title_font_size : '');
            setShortDescription(homepageBaivietSelected.short_description ? homepageBaivietSelected.short_description : '')
            setShortDescriptionFont(homepageBaivietSelected.short_description_font ? homepageBaivietSelected.short_description_font : '')
            setShortDescriptionFontSize(homepageBaivietSelected.short_description_font_size ? homepageBaivietSelected.short_description_font_size : '')
            setImage(homepageBaivietSelected.image ? homepageBaivietSelected.image : '');
            setContent(homepageBaivietSelected.content ? homepageBaivietSelected.content : '')
        }
    }, [homepageBaivietSelected])

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        address: "",
        note: "",
        paymentMethod: "cod",
        itemId,
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(BaivietAction.sendOrder(formData));
    };

    return (<>
        <title>{title} | Xe điện SH - Xe điện Song Đan</title>

        <Helmet>
            <style>{`
                .post-show .post-title {
                    ${titleFont ? "font-family: " + titleFont + " !important;" : ""}
                    ${titleFontSize ? "font-size: " + titleFontSize + "px !important;" : ""}
                }

                .post-show .post-short-description {
                    ${shortDescriptionFont ? "font-family: " + shortDescriptionFont + " !important;" : ""}
                    ${shortDescriptionFontSize ? "font-size: " + shortDescriptionFontSize + "px !important;" : ""}
                }
            `}</style>
        </Helmet>

        {isLoading && <div className='loading'></div>}

        {!isLoading && <div className='post-show'>
            <h2 className='post-title'>
                {title}
            </h2>
            <div className='post-short-description'>
                {shortDescription}
            </div>
            {image?.match(/\.(mp4|webm|ogg)$/i) ? (
                <video className='post-img media-item' src={image} controls />
            ) : (
                <img className='post-img media-item' src={image} alt={title} />
            )}
            <div className='post-content media-content' dangerouslySetInnerHTML={{ __html: content }} />
        </div>}
    </>);
};

export default TheHomepageBaivietOne;